import React from "react";

/**
 * Closing tagline below the section cards. Wrap *…* fragments in the API
 * payload to render them with the gradient italic style.
 */
const ClosingTagline = ({ section }) => {
  if (!section?.text) return null;
  const parts = section.text.split(/(\*[^*]+\*)/g).filter(Boolean);
  return (
    <p className="corp-tagline text-xl font-medium leading-snug text-[#444] mt-2">
      {parts.map((part, i) =>
        part.startsWith("*") && part.endsWith("*") ? (
          <span key={i} className="corp-gradient-text">
            {part.slice(1, -1)}
          </span>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </p>
  );
};

export default ClosingTagline;
